import type {
  CurrencyAmount,
  IsoDateTime,
} from '@omnipresentgroup/design-system';

import type { Address, Country } from '../common';

export enum PaymentMethod {
  MANUAL_BANK_TRANSFER = 'MANUAL_BANK_TRANSFER',
  CREDIT_CARD = 'CREDIT_CARD',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export enum FeeType {
  MANAGEMENT = 'MANAGEMENT',
  LIABILITY_SHIELD = 'LIABILITY_SHIELD',
}

export type IBANBankAccount = {
  bankAccountType: 'IBAN';
  iban: string;
  swiftBic?: string;
};

export type GBBankAccount = {
  bankAccountType: 'GB';
  accountNumber: string;
  sortCode: string;
};

export type ContractorPaymentTransferDetails = {
  bankAccount: {
    ownerName: string;
    ownerAddress: Address;
  } & (IBANBankAccount | GBBankAccount);
  wireReference: string;
};

export type Fx = {
  conversion: {
    fromCurrency: string;
    toCurrency: string;
    effectiveRate: string;
  };
  markupRate: string;
};

export type Fee = {
  amount: CurrencyAmount;
  type: FeeType;
  month?: string;
};

export type BaseQuote = {
  baseAmount: CurrencyAmount;
  convertedAmount: CurrencyAmount;
  fees: Fee[];
  transferAmount: CurrencyAmount;
  fx?: Fx;
  vatRate: string;
  country: Country;
};

export type InvoiceQuote = BaseQuote & {
  invoiceId: string;
  invoiceRef: string;
  contractor: { id: string; name: string };
};

export type ContractorPaymentQuote = {
  quoteId: string;
  expiresAt: IsoDateTime;
  invoiceBreakdown: InvoiceQuote[];
  quoteSummary: BaseQuote;
  paymentType: PaymentMethod;
};

export type ContractorPayment = {
  id: string;
  createdAt: IsoDateTime;
  transferDetails?: ContractorPaymentTransferDetails;
  transferDetailsAvailableUntil: IsoDateTime;
  fundsReceivedAt?: IsoDateTime;
  paidOutAt?: IsoDateTime;
  quote: ContractorPaymentQuote;
};
